import React from "react";
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import './Header.css';
import { useNavigate, Link } from "react-router-dom";


const Header = () => {
    const navigate = useNavigate();
    return (
        <>
            <div className="header-top">
                <div className="container">
                    <div className="row">
                        {/* <div className="col-md-6"><WatchLaterIcon className="watchicon" />   Monday to Saturday – 9 to 7 pm, Sunday closed</div> */}
                        <div className="col-md-6 headertop-left">
                            <div className="d-flex">
                                <div className="header-icon-box-wrapper">

                                    <div className="header-icon-box">

                                        <LocalPhoneIcon className="header-icon" />
                                    </div>

                                    <div className="header-icon-box-content">

                                        <h6 className="header-icon-box-title mb-0">
                                            Helpline
                                        </h6>

                                        <p className="header-icon-box-description mb-0">
                                            <a href="tel:+91 836 853 9434">
                                                +91- 83685 39434
                                            </a>
                                        </p>

                                    </div>

                                </div>
                                <div className="header-icon-box-wrapper">

                                    <div className="header-icon-box">
                                        <EmailIcon className="header-icon" />
                                    </div>

                                    <div className="header-icon-box-content">

                                        <h6 className="header-icon-box-title mb-0">

                                            Send Us Email
                                        </h6>

                                        <p className="header-icon-box-description mb-0">
                                            <a href="mailto:Info@crederefinance.com"> Info@crederefinance.com	</a>			</p>

                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 headertop-right">
                            <p className="mb-0"><PermPhoneMsgIcon /> Book a Free Call</p>
                            <button className="partner-btn" onClick={() => navigate("/become-a-partner")}>Become a Partner</button>
                        </div>

                    </div>
                </div>
            </div>
            <nav className="navbar navbar-expand-lg headerbtm">
                <div className="container">
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo01" aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarTogglerDemo01">
                        <Link className="navbar-brand" to="/">
                            <img src="images/logo1.png" alt="Credere Logo" className="header-logo" />
                        </Link>
                        <ul className="navbar-nav m-auto">
                            <li className="nav-item">
                                <a className="nav-link active" href="/about-us">
                                    About Us
                                </a>
                            </li>
                            <li className="nav-item dropdown nested-dropdown">
                                <a className="nav-link dropdown-toggle" id="aboutDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" href="#">Abroad Education Loan</a>
                                <ul className="dropdown-menu" aria-labelledby="aboutDropdown">
                                    <li><a className="dropdown-item" href="/abroad-education-loan-overview">Abroad Education Loan Overview</a></li>

                                    <li className="dropdown-submenu position-relative">
                                        <a className="dropdown-item dropdown-toggle" href="#">Our Landing Partners</a>
                                        <ul className="dropdown-menu">
                                            <li><a className="dropdown-item" href="/auxilo-lending-partner">Auxilo Lending Partner</a></li>
                                            <li><a className="dropdown-item" href="/avanse-lending-partner">Avanse Lending Partner</a></li>
                                            <li><a className="dropdown-item" href="/axis-bank-lending-partner">Axis Bank Lending Partner</a></li>
                                            <li><a className="dropdown-item" href="/bob-lending-partner">BOB Lending Partner</a></li>
                                            <li><a className="dropdown-item" href="/icici-bank-lending-partner">ICICI Bank Lending Partner</a></li>
                                            <li><a className="dropdown-item" href="/idfc-first-lending-partner">IDFC-First Lending Partner</a></li>
                                            <li><a className="dropdown-item" href="/incred-lending-partner">InCred Lending Partner</a></li>
                                            <li><a className="dropdown-item" href="/hdfc-credila-lending-partner">HDFC Credila Lending Partner</a></li>
                                            <li><a className="dropdown-item" href="/mpower-financing-lending-partner">MPOWER Financing Lending Partner</a></li>
                                            <li><a className="dropdown-item" href="/prodigy-finance-lending-partner">Prodigy Finance Lending Partner</a></li>
                                            <li><a className="dropdown-item" href="/sbi-lending-partner">SBI Lending Partner</a></li>
                                            <li><a className="dropdown-item" href="/tata-capital-lending-partner">Tata Capital Lending Partner</a></li>
                                            <li><a className="dropdown-item" href="/ubi-education-lending-partner">UBI Education Lending Partner</a></li>

                                        </ul>
                                    </li>
                                    <li><a className="dropdown-item" href="/interest-rates">Interest Rates</a></li>
                                    {/* <li><a className="dropdown-item" href="/education-loan-emi-calculator">Education Loan EMI Calculator</a></li> */}
                                    <li><Link to="/check-loan-eligibility" className="dropdown-item">Check Loan Eligibilty</Link></li>
                                </ul>
                            </li>
                            {/* <li className="nav-item dropdown nested-dropdown">
                                <a className="nav-link dropdown-toggle" id="aboutDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" href="#">Study Abroad</a>
                                <ul className="dropdown-menu" aria-labelledby="aboutDropdown">
                                    <li><a className="dropdown-item" href="/overview">Overview</a></li>
                                    <li className="dropdown-submenu position-relative">
                                        <a className="dropdown-item dropdown-toggle" href="/courses">Courses</a>
                                        <ul className="dropdown-menu">
                                            <li><a className="dropdown-item" href="/mis">MIS</a></li>
                                            <li><a className="dropdown-item" href="/masters-in-materials-science">Masters in Materials Science</a></li>
                                            <li><a className="dropdown-item" href="/masters-in-mechanical-engineering">Master in Mechanical Engineering</a></li>
                                            <li><a className="dropdown-item" href="/masters-in-financial-engineering">Masters in Financial Engineering</a></li>
                                            <li><a className="dropdown-item" href="/masters-in-environmental-engineering">Masters in Environmental Engineering</a></li>
                                            <li><a className="dropdown-item" href="/master-in-data-science">Master in Data Science</a></li>
                                            <li><a className="dropdown-item" href="/masters-of-engineering-management">Masters in Engineering Management</a></li>
                                            <li><a className="dropdown-item" href="/masters-in-electrical-engineering">Masters in Electrical Engineering</a></li>
                                            <li><a className="dropdown-item" href="/master-in-computer-science">Computer Science</a></li>
                                            <li><a className="dropdown-item" href="/masters-in-aerospace-engineering">Masters in Aerospace Engineering</a></li>
                                            <li><a className="dropdown-item" href="/masters-in-chemical-engineering">Chemical Engineering</a></li>
                                            <li><a className="dropdown-item" href="/masters-in-biomedical-engineering">Biomedical Engineering</a></li>
                                            <li><a className="dropdown-item" href="/masters-in-business-analytics">Business Analytics</a></li>
                                            <li><a className="dropdown-item" href="/masters-in-civil-engineering">Masters in Civil Engineering</a></li>
                                            <li><a className="dropdown-item" href="/masters-in-bioengineering">Bio Engineering</a></li>
                                        </ul>
                                    </li>
                                    <li className="dropdown-submenu position-relative">
                                        <a className="dropdown-item dropdown-toggle" href="/best-countries-to-study-abroad">Countries</a>
                                        <ul className="dropdown-menu">
                                            <li><a className="dropdown-item" href="/usa">USA</a></li>
                                            <li><a className="dropdown-item" href="/uk">UK</a></li>
                                            <li><a className="dropdown-item" href="/canada">Canada</a></li>
                                            <li><a className="dropdown-item" href="/australia">Australia</a></li>
                                            <li><a className="dropdown-item" href="/france">France</a></li>
                                            <li><a className="dropdown-item" href="/germany">Germany</a></li>
                                            <li><a className="dropdown-item" href="/Ireland">Ireland</a></li>
                                            <li><a className="dropdown-item" href="/new-zealand">New Zealand</a></li>
                                        </ul>
                                    </li>
                                    <li className="dropdown-submenu position-relative">
                                        <a className="dropdown-item dropdown-toggle" href="#">Exam</a>
                                        <ul className="dropdown-menu">
                                            <li><a className="dropdown-item" href="/act">ACT</a></li>
                                            <li><a className="dropdown-item" href="/pte">PTE</a></li>
                                            <li><a className="dropdown-item" href="/sat">SAT</a></li>
                                            <li><a className="dropdown-item" href="/gre">GRE</a></li>
                                            <li><a className="dropdown-item" href="/toefl">TOEFL</a></li>
                                            <li><a className="dropdown-item" href="/ielts">IELTS</a></li>
                                        </ul>
                                    </li>
                                </ul>
                            </li> */}
                            <li className="nav-item">
                                <a className="nav-link" href="/abroad-scholarships">Scholarships</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="/refer-earn">Refer & Earn</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="/blog">Blogs</a>
                            </li>
                        </ul>
                        <div className="headerbtm-right">
                            <button className="loan-btn" onClick={() => navigate("/check-loan-eligibility")}>Apply For Loan</button>
                        </div>
                    </div>
                </div >
            </nav >
        </>
    )
}

export default Header;